const handleSessionExpired = () => {
  const returnTo =
    window.location.pathname + window.location.search + window.location.hash;
  window.location.assign(`/logout?returnTo=${encodeURIComponent(returnTo)}`);
};

export default handleSessionExpired;
